/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const MinusIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M3.5 12c0-.552.476-1 1.063-1h14.875c.586 0 1.062.448 1.062 1s-.476 1-1.062 1H4.563c-.587 0-1.063-.448-1.063-1" clipRule="evenodd" /></svg>;
};
export default MinusIcon;